export default {
  getCities: state => state.cities.sort((a, b) => a.index - b.index),
  getCity: state => city => state.cities.find(el => el.id === city),
  getCurrentCity: state => state.currentCity,
  getCtxButtons: state => state.ctxButtons,
  getDataCity: state => city => state.dataPageCities.find(el => el.id === city),
  getDataAbout: state => state.pageAbout,
  getDataCityComponent: (state, getters) => (city, component) =>
    getters.getDataCity(city).data[component],
  getStateVideo: state => state.videoIsPlaying,
  getStateAudio: state => state.userStopAudio,
};



// WEBPACK FOOTER //
// ./src/store/getters.js